// frontend/src/components/charts/CountryBars.jsx
import React from "react";
import PropTypes from "prop-types";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import ChartCard from "./ChartCard";

/**
 * CountryBars — top countries by scan count as horizontal bars.
 *
 * @param {{
 *   data: Array<{ country_code: string, count: number }>,
 *   title?: string
 * }} props
 */
function CountryBars({ data, title = "Top countries" }) {
  return (
    <ChartCard title={title} isEmpty={data.length === 0}>
      <ResponsiveContainer
        width="100%"
        height={Math.max(180, data.length * 32)}
      >
        <BarChart
          data={data}
          layout="vertical"
          margin={{ top: 0, right: 24, bottom: 0, left: 8 }}
        >
          <CartesianGrid
            strokeDasharray="3 3"
            horizontal={false}
            stroke="#f0f0f0"
          />
          <XAxis
            type="number"
            allowDecimals={false}
            tick={{ fontSize: 11, fill: "#6b7280" }}
            tickLine={false}
            axisLine={false}
          />
          <YAxis
            type="category"
            dataKey="country_code"
            width={48}
            tick={{ fontSize: 11, fill: "#374151" }}
            tickLine={false}
            axisLine={false}
          />
          <Tooltip cursor={{ fill: "#eff6ff" }} />
          <Bar
            dataKey="count"
            fill="#2563eb"
            radius={[0, 4, 4, 0]}
            maxBarSize={24}
          />
        </BarChart>
      </ResponsiveContainer>
    </ChartCard>
  );
}
CountryBars.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      country_code: PropTypes.string,
      count: PropTypes.number,
    }),
  ).isRequired,
  title: PropTypes.string,
};

export default CountryBars;
